let state = {
  dAppState: "NOT_CONNECTED",
  isTransactionPending: false,

  //Component states
  zoomContribution: 0,
};

export default state;
